// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleteaccount-input-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 14px 16px;
  gap: 12px;
  background: #f3f5f7;
  border-radius: 12px;
}

.deleteaccount-section {
  margin-top: 15px;
}

.deleteaccount-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 380px;
}

.deleteaccount-content {
  padding: 30px 24px 30px 24px;
  gap: 24px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
}

.deleteaccount-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.deleteaccount-content .form-group {
  margin-bottom: 0px;
}

.deleteaccount-content .form-group label {
  color: #141718;
}`, "",{"version":3,"sources":["webpack://./src/Components/DeleteAccount/deleteaccount.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,4BAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".deleteaccount-input-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 14px 16px;\n  gap: 12px;\n  background: #f3f5f7;\n  border-radius: 12px;\n}\n\n.deleteaccount-section {\n  margin-top: 15px;\n}\n\n.deleteaccount-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 380px;\n}\n\n.deleteaccount-content {\n  padding: 30px 24px 30px 24px;\n  gap: 24px;\n  background: #fefefe;\n  border: 1px solid #e8ecef;\n  border-radius: 12px;\n}\n\n.deleteaccount-content h4 {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.deleteaccount-content .form-group {\n  margin-bottom: 0px;\n}\n\n.deleteaccount-content .form-group label {\n  color: #141718;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
